var React = require("react");
import AddSample from "../AddSample";
import PhoneInput from "../inputs/phone.js";
import TextInput from "../inputs/text.js";
import SampleSummary from "../SampleSummary";
import OrderSubmitButton from "./order_submit_button";
import WaterChemistryOption from "./water_chemistry_option";
import QuantityErrorMessage from "./QuantityErrorMessage";

class NewOrderForm extends React.Component {
    render() {
        return (
            <div className="width-100">
                <form action="/order/create" method="post">
                    <input
                        type="hidden"
                        name="authenticity_token"
                        value={this.props.authenticationToken}
                    />

                    <div className="row margin-top-md">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-left">
                            <h4>
                                <div className="big-step-number">1</div>
                                Add your products
                                <AddSample
                                    store={this.props.store}
                                    actions={this.props.actions}
                                />
                            </h4>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <input
                        hidden
                        name="brewery_id"
                        readOnly={true}
                        value={this.props.store.brewery.id}
                        type="text"
                    />
                    <input
                        hidden
                        name="client_facing"
                        readOnly={true}
                        value={this.props.clientFacing}
                        type="text"
                    />

                    <div className="row margin-top-sm margin-bottom-sm">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-center">
                            <hr className="alt" />
                        </div>
                        <div className="col-sm-3"></div>
                    </div>

                    <div className="row margin-top-sm">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-left">
                            <h4>
                                <div className="big-step-number margin-bottom-md">
                                    2
                                </div>
                                Add your water
                            </h4>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className="new-order-padded">
                        <WaterChemistryOption
                            actions={this.props.actions}
                            store={this.props.store}
                        />
                    </div>
                    <div className="row margin-top-sm margin-bottom-sm">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-center">
                            <hr className="alt" />
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className="row margin-top-sm margin-bottom-sm">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-left">
                            <h4>
                                <div className="big-step-number">3</div>
                                Order contact
                            </h4>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className="new-order-padded contact-detail">
                        <div className="row margin-top-sm margin-bottom-sm">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-6 text-left">
                                <div>
                                    <label>Contact Name </label>
                                    <TextInput
                                        store={this.props.store}
                                        actions={this.props.actions}
                                        fields={this.props.store.fields}
                                        name={"contact_name"}
                                    />
                                </div>
                                <div>
                                    <label>Phone </label>
                                    <PhoneInput
                                        store={this.props.store}
                                        actions={this.props.actions}
                                        fields={this.props.store.fields}
                                        name={"phone"}
                                    />
                                </div>
                                <div>
                                    <label>Email </label>
                                    <TextInput
                                        store={this.props.store}
                                        actions={this.props.actions}
                                        fields={this.props.store.fields}
                                        name={"email"}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                    </div>
                    <div className="row margin-top-md margin-bottom-sm">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-center">
                            <hr className="alt" />
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className="row margin-top-sm margin-bottom-sm">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-left">
                            <h4>
                                <div className="big-step-number">4</div>
                                Review and submit your order
                            </h4>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className="row margin-top-lg margin-bottom-xxxl">
                        <div className="col-sm-3"></div>
                        <div className="col-sm-6 text-left">
                            <div className="new-order-padded">
                                <SampleSummary store={this.props.store} />
                            </div>
                        </div>
                        <div className="col-sm-3"></div>
                    </div>
                    <div className="fixed-total">
                        <div className="row margin-top-sm total-summary">
                            <QuantityErrorMessage store={this.props.store} />
                            <div className="w100">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6 text-right">
                                    Your total for this order is{" "}
                                    <span className="big-number dollar">$</span>
                                    <span className="big-number">
                                        {this.props.store.finalCost}
                                    </span>
                                    <input
                                        name="order_total"
                                        hidden
                                        type="text"
                                        value={
                                            this.props.store.finalCost || 0.0
                                        }
                                        readOnly
                                    />
                                </div>
                                <div className="col-sm-3"></div>
                            </div>
                        </div>
                        <div className="row margin-top-sm">
                            <div className={"w100"}>
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6 text-right">
                                    <i>
                                        Please indicate in product notes if TTB
                                        certification will be required.
                                    </i>
                                </div>
                                {/*<div className="col-sm-6 text-right">*/}
                                {/*<input*/}
                                {/*className="user-checkbox"*/}
                                {/*id="ttb-certification"*/}
                                {/*value="true"*/}
                                {/*type="checkbox"*/}
                                {/*name={`ttb-certification`}*/}
                                {/*onClick={(e) => {*/}
                                {/*this.checkboxClick('ttb-certification', e);*/}
                                {/*}}*/}
                                {/*/>*/}
                                {/*<span className="option-label">*/}
                                {/*TTB certification will be required*/}
                                {/*</span>*/}
                                {/*</div>*/}
                                <div className="col-sm-3"></div>
                            </div>
                        </div>
                        <div className="row margin-bottom-sm">
                            <div className="w100">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-6">
                                    <OrderSubmitButton
                                        actions={this.props.actions}
                                        store={this.props.store}
                                    />
                                </div>
                                <div className="col-sm-3"></div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default NewOrderForm;
